import { Navigate, type RouteObject, useLocation } from 'react-router-dom';

import { isAuthenticated } from './lib/auth';
import { AccountPage } from './pages/Account';
import { BuyPage } from './pages/Buy';
import { CheckoutPage } from './pages/Checkout';
import { HomePage } from './pages/Home';
import { LoginPage } from './pages/Login';
import { MyOrdersPage } from './pages/MyOrders';
import { MyRefundsPage } from './pages/MyRefunds';
import { OrderConfirmPage } from './pages/OrderConfirm';
import { OrderDetailPage } from './pages/OrderDetail';
import { ProductDetailPage } from './pages/ProductDetail';
import { RecommendationsPage } from './pages/Recommendations';
import { RefundDetailPage } from './pages/RefundDetail';
import { RefundRequestPage } from './pages/RefundRequest';
import { TicketQRPage } from './pages/TicketQR';

function RequireAuth({ children }: { children: JSX.Element }): JSX.Element {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}

export const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <RequireAuth>
        <HomePage />
      </RequireAuth>
    ),
  },
  {
    path: '/recommendations',
    element: (
      <RequireAuth>
        <RecommendationsPage />
      </RequireAuth>
    ),
  },
  {
    path: '/products/:id',
    element: (
      <RequireAuth>
        <ProductDetailPage />
      </RequireAuth>
    ),
  },
  {
    path: '/products/:id/buy',
    element: (
      <RequireAuth>
        <BuyPage />
      </RequireAuth>
    ),
  },
  {
    path: '/orders/:id/checkout',
    element: (
      <RequireAuth>
        <CheckoutPage />
      </RequireAuth>
    ),
  },
  {
    path: '/orders/:id/confirm',
    element: (
      <RequireAuth>
        <OrderConfirmPage />
      </RequireAuth>
    ),
  },
  {
    path: '/orders/:id',
    element: (
      <RequireAuth>
        <OrderDetailPage />
      </RequireAuth>
    ),
  },
  {
    path: '/tickets/:id',
    element: (
      <RequireAuth>
        <TicketQRPage />
      </RequireAuth>
    ),
  },
  {
    path: '/tickets/:id/refund',
    element: (
      <RequireAuth>
        <RefundRequestPage />
      </RequireAuth>
    ),
  },
  {
    path: '/refunds/:id',
    element: (
      <RequireAuth>
        <RefundDetailPage />
      </RequireAuth>
    ),
  },
  {
    path: '/me/orders',
    element: (
      <RequireAuth>
        <MyOrdersPage />
      </RequireAuth>
    ),
  },
  {
    path: '/me/refunds',
    element: (
      <RequireAuth>
        <MyRefundsPage />
      </RequireAuth>
    ),
  },
  {
    path: '/me/account',
    element: (
      <RequireAuth>
        <AccountPage />
      </RequireAuth>
    ),
  },
  { path: '/login', element: <LoginPage /> },
  { path: '*', element: <Navigate to="/" replace /> },
];
